import { Component, Input } from '@angular/core';

import { SanitizeHtmlPipe } from '../sanitize-html.pipe';

@Component({
  selector: 'fcp-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss'],
})
export class DynamicTableComponent {
  @Input() public data;

  setStyleTable(str) {
    if (str) {
      return str
        .replace(/<table/gi, '<div class="responsive-table"><table')
        .replace(/<\/table>/gi, '</table></div>');
    }
  }
}
